var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "5716d96b085bad7df96b573b4174641f58887fc9"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dubbot-react@dubbot-5f"] = {
  id: "5716d96b085bad7df96b573b4174641f58887fc9"
};